import i18next from 'i18next';
import {mainPath} from "../routes/paths";

export const getProjectStatus = (status) => {
    const PROJECT_STATUS = {
        active: i18next.t('CompaniesHome.active'),
        pause: i18next.t('CompaniesHome.paused'),
        done: i18next.t('CompaniesHome.done')
    };

    return PROJECT_STATUS[status] ?? '';
};

export const dateFormatWithTime = 'DD.MM.YYYY HH:mm';
export const dateFormat = 'DD.MM.YYYY';

export const mimeTypesMap = {
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'text/plain': 'txt',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx'
};
export const mimeTypesBrowserSupport = [
    'application/pdf', // PDF documents
    'image/jpeg', // JPEG images
    'image/png', // PNG images
    'image/gif', // GIF animations
    'image/webp', // WebP images
    'image/svg+xml' // SVG images
];
export const PERMISSIONS = {
    COMPANY_CREATE: 'company_create',
    COMPANY_READ: 'company_read',
    COMPANY_EDIT: 'company_edit',
    CREATE_REPORTS: 'report_create',
    CUSTOMER_CREATE: 'customer_create',
    CUSTOMER_EDIT: 'customer_edit',
    CUSTOMER_LIST: 'customer_list',
    CUSTOMER_BLOCK: 'customer_block',
    CUSTOMER_RETURN: 'customer_return',
    DOCUMENT_CREATE: 'document_create',
    DRAWING_CREATE: 'drawing_create',
    DRAWING_REQUEST: 'drawing_request',
    DRAWING_REMOVE: 'drawing_remove',
    DRAWING_LIST: 'drawing_list',
    CHAT_READ_MEMBERS: 'chat_read_members',
    ESTIMATE_CREATE: 'estimate',
    ESTIMATE_REMOVE: 'estimate_remove',
    ESTIMATE_REQUEST: 'estimate_request',
    ESTIMATE_LIST: 'estimate_list',
    ESTIMATE_ACCEPT: 'estimate_accept',
    DRAWING_ACCEPT: 'drawing_accept',
    DRAWING_REMEMBER: 'drawing_remember',
    DOCUMENT_REMEMBER: 'document_remember',
    DOCUMENT_LIST: 'document_list',
    DOCUMENT_STATUS_EDIT: 'document_payment_status_edit',
    DRAWING_STATUS_EDIT: 'drawing_order_status_edit',
    DOCUMENT_REQUEST: 'document_request',
    DOCUMENT_ACCEPT: 'document_accept',
    DOCUMENT_DOWNLOAD: 'document_download',
    DOCUMENT_REMOVE: 'document_remove',
    EMPLOYEE_CREATE: 'employee_create',
    EMPLOYEE_EDIT: 'employee_edit',
    PERMISSION_VIEW: 'permissions_view',
    USER_FULL_EDIT: 'user_full_edit',
    EMPLOYEE_FIRE: 'employee_fire',
    EMPLOYEE_LIST: 'employee_list',
    // EMPLOYEE_MARKS_READ: 'employee_marks_read',
    EMPLOYEE_REVIEW: 'employee_review',
    EMPLOYEE_RETURN: 'employee_return',
    PROJECT_CREATE: 'project_create',
    PROJECT_DOWNLOAD: 'project_download',
    PROJECT_EDIT: 'project_edit',
    PROJECT_FINISH: 'project_finish',
    PROJECT_MEMBER_ADD: 'project_members_add',
    PROJECT_MEMBER_EDIT: 'project_members_edit',
    PROJECT_EMPLOYEE_EDIT: 'employee_edit',
    PROJECT_MEMBER_READ: 'project_members_read',
    PROJECT_MEMBER_REMOVE: 'project_members_remove',
    PROJECT_PAUSE: 'project_pause',
    PROJECT_RESUME: 'project_resume',
    REMOVE_REPORTS: 'report_remove',
    REPORT_VIEW: 'report_view',
    REPORT_DOWNLOAD: 'report_download',
    SENDING_NEWSLETTERS: 'sending_newsletters',
    LOCATION_CREATE: 'location_create',
    MEMBER_PROJECT_LIST: 'member_project_list',
    PROJECT_DELETE: 'project_delete',
    CHAT_MESSAGES: 'chat_messages',
};

export const ROLES = {
    SUPER_ADMIN: 'super-admin',
    HEAD_OF_BRANCH: 'head_of_branch',
    TECHNICAL_DIRECTOR: 'technical_director',
    HEAD_OF_THE_SALES_DEPARTMENT: 'head_of_the_sales_department',
    MAIN_DESIGNER: 'main_designer',
    PROJECT_MANAGER: 'project_manager',
    FOREMAN: 'foreman',
    DESIGNER: 'designer',
    PROVIDER: 'provider',
    CLIENT: 'user',
    SPECTATOR: 'spectator',
    DEMO: 'demo',
    FINANCIER: 'financier',
};


export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const isUrl = (string) => {
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
export const parseTextWithLinks = (text) => {
    if (text) {
        const parts = text.split(/(https?:\/\/[^\s]+|www\.[^\s]+)/gi).map((part, index) => {
            if (/^(https?:\/\/|www\.)/.test(part)) {
                const href = part.startsWith('http') ? part : `https://${part}`;
                return (
                    <a key={index} href={href} target="_blank" rel="noopener noreferrer">
                        {part}
                    </a>
                );
            } else {
                return part;
            }
        });


        return <div>{parts}</div>;
    }
    return '';
    // Возвращаем текст и ссылки внутри <div>
};

export const passwordRegex = /^(?=.*[A-ZА-Я])(?=.*\d).{8,}$/

export const projectPathWithFilter = (id,filter) => {
    if(filter && filter !== 'all') {
        return mainPath.project.replace(':id', id) + `?pS=${filter}`
    }
    return mainPath.project.replace(':id', id)

}
